import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { ECoachRatingQueryKey, ECoachRatingQueryUrl } from "@/3514/config"
import type { ICoachRatingDto, ICoachRatingTypeDto } from "@/3514/types"
import { extractNumberFromQueryKeyPart, extractStringFromQueryKeyPart } from "@/3514/utils"

async function coachRatingFetcher({
    queryKey
}: QueryFunctionContext<ReturnType<typeof ECoachRatingQueryKey>>): Promise<ICoachRatingDto> {
    const { data }: AxiosResponse<ICoachRatingDto> = await axiosClient.get(
        ECoachRatingQueryUrl({
            type: extractStringFromQueryKeyPart<ICoachRatingTypeDto>(queryKey[1]),
            participantId: extractNumberFromQueryKeyPart(queryKey[2])
        })
    )

    return data
}

export { coachRatingFetcher }
